import { shopifyAuthenticatedFetch } from '@/utils/shopifyAuthenticatedFetch'

export async function getSignedYuzuConnectUrl(url: string) {
  const response = await shopifyAuthenticatedFetch(
    '/api/integrations/yuzu/shop-handoff',
    { method: 'POST' },
  )
  if (!response.ok) throw new Error('Could not open Yuzu. Please try again.')
  const { shop, token }: { shop: string; token: string } = await response.json()
  const destination = new URL(url)
  destination.searchParams.set('shop', shop)
  destination.searchParams.set('giftie_handoff', token)
  return destination.toString()
}
